module.exports = __webpack_public_path__ + "static/media/settingGroupIcon.72e35787.svg";